module.exports = __webpack_public_path__ + "img/jboard_icon-33.e2ad6428.png";